import { useEffect } from 'react';
import '@/i18n/config';

export const I18nProvider = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        // Ensure i18n is initialized
        // The config file already initializes i18n, this is just a wrapper
    }, []);

    return <>{children}</>;
};

